import React from 'react'
import { FilterTabWrapper } from './styles'
import { useFormContext } from 'react-hook-form'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import { SearchButton } from '../Button'
import { integerNumberOnly } from './advanceSearchOptions'
import { advanceSearchOptions } from './Defines/detailTabDefine'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import { minimumInputNumber, maximumInputNumber } from '../../tools/constants'
import RegisterMultiSelect from '../RegisterMultiSelect'
import { dropdownCategory, getDropDownOptions } from '../../common/const'
import { dropDownContentListApi } from '../../features/dropdown/dropdownAPI'

export default function DetailVehicleTab (props) {
  const { register, handleSubmit, getValues, setValue, watch, formState: { errors }, setError, clearErrors } = useFormContext()
  const { onSearchSubmit } = props
  const [errorFields, setErrorFields] = React.useState([])
  const watchAdvancedSelected = watch([...Array(9).keys()].slice(1).map(x => 'advanceSearchLabel_' + x))
  const allowedChars = '0123456789.'
  const [prevAdvancedSearchVal, setPrevAdvancedSearchVal] = React.useState('')
  const [DropDownList, setDropDownList] = React.useState({})
  const address = watch('license.address')
  const classNo = watch('license.classNo')
  const number = watch('license.number')

  React.useEffect(() => {
    setDropDownList({})
    // Get DropDown data
    const dropdownKey = {
      0: dropdownCategory.body,
      1: dropdownCategory.bodyManufacturer,
      2: dropdownCategory.wing,
      3: dropdownCategory.powerGate,
      4: dropdownCategory.powerManufacturer,
      5: dropdownCategory.craneManufacturer,
      6: dropdownCategory.withJorder,
      7: dropdownCategory.airSuspension,
      8: dropdownCategory.refrigeratorManufacturer,
      9: dropdownCategory.refrigeratorModel,
      10: dropdownCategory.inVehicleFreezingEquipment,
      11: dropdownCategory.temperatureRecord,
      12: dropdownCategory.standBy,
      13: dropdownCategory.etcTwo,
      14: dropdownCategory.adBlue,
      15: dropdownCategory.dashcamManufacturer,
      16: dropdownCategory.backEyeCameraManufacturer,
      17: dropdownCategory.cornerSensor,
      18: dropdownCategory.digiTachoManufacture
    }
    Object.entries(dropdownKey).map(async (value) => {
      const response = await dropDownContentListApi({ categoryId: value[1] })
      // setDropDownListを更新
      setDropDownList(prevState => ({ ...prevState, [value[1]]: response.data.rows }))
    })
  }, [])

  const onSubmit = data => {
    onSearchSubmit(data)
  }

  const getSelectedStatus = (formKey, value) => {
    const curSelected = getValues(formKey)

    const selectedItems = [
      getValues('advanceSearchLabel_11'),
      getValues('advanceSearchLabel_12'),
      getValues('advanceSearchLabel_13'),
      getValues('advanceSearchLabel_14'),
      getValues('advanceSearchLabel_15'),
      getValues('advanceSearchLabel_16'),
      getValues('advanceSearchLabel_17'),
      getValues('advanceSearchLabel_18'),
      getValues('advanceSearchLabel_19')
    ]
    if (value !== curSelected && selectedItems.includes(value)) {
      return true
    }
    return false
  }

  const addZeroBeforeDot = (item) => {
    if (getValues(item).length === 1) {
      getValues(item).charAt(0) === '.' && setValue(item, `0${getValues(item)}0`)
    } else {
      getValues(item).charAt(0) === '.' && setValue(item, `0${getValues(item)}`)
    }
  }

  const errorMessage = `${i18n.t('VEHICLE_VEHICLE-LIST_POPUP-WARNING2_LABEL')}`
  const errorMessage2 = `${i18n.t('VEHICLE_VEHICLE-LIST_WARNING-NUMERIC_LABEL')}`
  const showError = (num) => {
    const advanceSearchValue = getValues(`advanceSearchLabel_${num}`)
    // START: Find datatype
    const idx = advanceSearchOptions.map((e) => e.value).indexOf(advanceSearchValue)
    if (!advanceSearchValue || advanceSearchValue === '1') return
    const advanceSearchItem = advanceSearchOptions[idx]
    const dataType = advanceSearchItem.type && advanceSearchItem.type.split(' - ')
    // END: Find datatype
    const from = getValues(`advanceSearchInput_${num}_${advanceSearchValue}.from`)
    const to = getValues(`advanceSearchInput_${num}_${advanceSearchValue}.to`)
    // START: Clear Error
    const indexErr = errorFields.indexOf(`advanceSearchInput_${num}_${advanceSearchValue}.from`)
    if (indexErr > -1) {
      errorFields.splice(indexErr, 1)
    }
    const indexPrevErr = errorFields.indexOf(`advanceSearchInput_${num}_${prevAdvancedSearchVal}.from`)
    if (indexPrevErr > -1) {
      errorFields.splice(indexPrevErr, 1)
    }
    clearErrors(`advanceSearchInput_${num}_${advanceSearchValue}.from`)
    // END: Clear Error
    if (dataType[0] === 'number') { // Handling error if textbox is numeric
      from && addZeroBeforeDot(`advanceSearchInput_${num}_${advanceSearchValue}.from`)
      to && addZeroBeforeDot(`advanceSearchInput_${num}_${advanceSearchValue}.to`)
      if (parseFloat(from) > parseFloat(to) && !Number.isNaN(from) && !Number.isNaN(to)) {
        setErrorFields(prevState => [...prevState, `advanceSearchInput_${num}_${advanceSearchValue}.from`])
        setError(`advanceSearchInput_${num}_${advanceSearchValue}.from`, { type: 'manual', message: errorMessage })
      }
      if ((from && !/^[0-9.]*$/.test(from)) || (to && !/^[0-9.]*$/.test(to))) {
        setErrorFields(prevState => [...prevState, `advanceSearchInput_${num}_${advanceSearchValue}.from`])
        setError(`advanceSearchInput_${num}_${advanceSearchValue}.from`, { type: 'manual', message: errorMessage2 })
      }
    }
    setPrevAdvancedSearchVal(getValues(`advanceSearchLabel_${num}`))
  }

  const showLicenseError = (item, name) => {
    const index = errorFields.indexOf(name)
    if (index > -1) {
      errorFields.splice(index, 1)
    }
    clearErrors(name)
    const licenseNum = getValues(item)
    if (licenseNum && !/^[0-9.]*$/.test(licenseNum)) {
      setErrorFields(prevState => [...prevState, name])
      setError(name, { type: 'manual', message: errorMessage2 })
    }
  }

  const contains = (stringValue, charValue) => {
    return stringValue.indexOf(charValue) > -1
  }
  const allowTypeNumericOnly = (e) => {
    const invalidKey = (e.key.length === 1 && !contains(allowedChars, e.key)) || (e.key === '.' && contains(e.target.value, '.'))
    return invalidKey && e.preventDefault()
  }

  const renderOptions = (num) => {
    const newOptions = [...advanceSearchOptions]
    return <div className="input-group input-flex">
      <select className="input-item" tabIndex={parseInt(num) + 3}
        style={{ marginLeft: '0' }}
        {...register(`advanceSearchLabel_${num}`)}
        data-testid={`advanceSearchLabel_${num}`}
        defaultValue={'1'}>
        <option value="1">{i18n.t('COMMON_COMMON_DROPDOWN-PLEASE-SELECT_LABEL')}</option>
        {newOptions.map(({ value, label }, index) => {
          return <option value={value} key={index} disabled={getSelectedStatus(`advanceSearchLabel_${num}`, value)}>{i18n.t(label)}</option>
        })}
      </select>
    </div>
  }

  const renderInput = (num) => {
    const advanceSearchValue = getValues(`advanceSearchLabel_${num}`)
    if (!advanceSearchValue || advanceSearchValue === '1') return
    const index = advanceSearchOptions.map((e) => e.value).indexOf(advanceSearchValue)
    const advanceSearchItem = advanceSearchOptions[index]
    advanceSearchItem.selected = true
    const dataType = advanceSearchItem.type && advanceSearchItem.type.split(' - ')
    switch (dataType[0]) {
      case 'dropdown':
        return (
          <div className="input-group input-flex">
            <RegisterMultiSelect
              className="input-item"
              marginLeft={'10px'}
              placeholder={i18n.t('COMMON_COMMON_DROPDOWN-OPTION-ALL_LABEL')}
              options={getDropDownOptions(advanceSearchItem.options, DropDownList)}
              valueField="key"
              labelField="value"
              element={{ value: `advanceSearchInput_${num}_${advanceSearchValue}` }}
            />
          </div>
        )
      case 'number':
        // Number.isNaN(parseFloat(getValues(`advanceSearchInput_${num}_${advanceSearchValue}.from`))) && setValue(`advanceSearchInput_${num}_${advanceSearchValue}.from`, '')
        // Number.isNaN(parseFloat(getValues(`advanceSearchInput_${num}_${advanceSearchValue}.to`))) && setValue(`advanceSearchInput_${num}_${advanceSearchValue}.to`, '')
        return (
          <div className="input-group input-flex">
            <input tabIndex={parseInt(num) + 3}
              {...!integerNumberOnly.includes(advanceSearchValue) && { step: 'any' }}
              onKeyDown={(e) => allowTypeNumericOnly(e)}
              placeholder='From'
              type='text'
              min={minimumInputNumber}
              max={maximumInputNumber}
              {...register(`advanceSearchInput_${num}_${advanceSearchValue}.from`)}
              data-testid={`advanceSearchInput_${num}_${advanceSearchValue}-from`}
              className="input-item" />
            <input tabIndex={parseInt(num) + 3}
              {...!integerNumberOnly.includes(advanceSearchValue) && { step: 'any' }}
              onKeyDown={(e) => allowTypeNumericOnly(e)}
              placeholder='To'
              type='text'
              min={minimumInputNumber}
              max={maximumInputNumber}
              {...register(`advanceSearchInput_${num}_${advanceSearchValue}.to`)}
              data-testid={`advanceSearchInput_${num}_${advanceSearchValue}-to`}
              className="input-item" />
          </div>)
      default:
        return (
          <div className="input-group input-flex">
            <input tabIndex={parseInt(num) + 3}
              placeholder=''
              type={dataType[0]}
              maxLength={advanceSearchItem.maxLength}
              {...register(`advanceSearchInput_${num}_${advanceSearchValue}`)}
              data-testid={`advanceSearchInput_${num}_${advanceSearchValue}`}
              className="input-item" />
          </div>)
    }
  }

  const renderSelect = (e, i) => {
    return <ul key={i}><li>
      <div className="item-container"
        onBlur={() => { showError(e) }}>
        {!watch(`advanceSearch_${e}`) &&
          <AddCircleOutlineIcon alt="addSearch" className="btn-add"
            style={{ alignSelf: 'center' }}
            {...register(`advanceSearch_${e}`)}
            {...watch(`advanceSearch_${e}`, false)}
            data-testid={`plus-icon-${e}`}
            onClick={() => setValue(`advanceSearch_${e}`, true)} />
        }
        {watch(`advanceSearch_${e}`) && watchAdvancedSelected && renderOptions(e)}
        {watch(`advanceSearchLabel_${e}`) && renderInput(e)}
      </div>
      {errors[`advanceSearchInput_${e}_${getValues(`advanceSearchLabel_${e}`)}`] && (
        <div className="error" data-testid={`error-text-${e}`}>{errors[`advanceSearchInput_${e}_${getValues(`advanceSearchLabel_${e}`)}`].from.message}</div>
      )}
    </li></ul>
  }

  return (
    <FilterTabWrapper>
      <form className="form-container" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="container">
          <div className="grid">
            <ul style={{ marginBottom: '0' }} ><li>
              <div style={{ flexDirection: 'column' }} >
                <div className="label-text"><label>{i18n.t('VEHICLE_COMMON_LICENSE-PLATE_LABEL')}</label></div>
                <div className="input-group" onBlur={(e) => { showLicenseError('license.number', 'license') }}>
                  <input
                    placeholder={i18n.t('VEHICLE_COMMON_LICENSE-PLATE-ADDRESS_LABEL')}
                    maxLength='255'
                    tabIndex='1'
                    value={address || ''}
                    onChange={(e) => setValue('license.address', e.target.value)}
                    data-testid={'license.address'}
                    style={{ marginLeft: '0' }}
                    className="input-item" />
                  <input
                    placeholder={i18n.t('VEHICLE_COMMON_LICENSE-PLATE-CLASS-NO_LABEL')}
                    maxLength='255'
                    tabIndex='2'
                    value={classNo || ''}
                    onChange={(e) => setValue('license.classNo', e.target.value)}
                    data-testid={'license.classNo'}
                    className="input-item" />
                  <input
                    placeholder={i18n.t('VEHICLE_COMMON_LICENSE-PLATE-NUMBER_LABEL')}
                    onKeyDown={(e) => { (e.key.length === 1 && !contains('0123456789', e.key)) && e.preventDefault() }}
                    type='text'
                    maxLength='4'
                    tabIndex='3'
                    value={number || ''}
                    onChange={(e) => setValue('license.number', e.target.value)}
                    data-testid={'license.number'}
                    // onKeyPress={handleTypeNumber}
                    className="input-item" />
                </div>
                {errors.license && (
                  <div className="error" data-testid={'error-text'}>{errors.license.message}</div>
                )}
              </div>
            </li></ul>
            <ul style={{ marginLeft: '20px', marginBottom: '0' }}><li>
              <div style={{ flexDirection: 'column' }} >
                <div className="label-text"><label>{i18n.t('VEHICLE_VEHICLE-LIST_ADVANCE-SEARCH_LABEL')}</label></div>
                <div className="item-container"
                  onBlur={() => { showError(11) }}>
                  {watchAdvancedSelected && renderOptions(11)}
                  {watch('advanceSearchLabel_11') && renderInput(11)}
                </div>
                {errors[`advanceSearchInput_11_${getValues('advanceSearchLabel_11')}`] && (
                  <div className="error" data-testid="error-text-1">{errors[`advanceSearchInput_11_${getValues('advanceSearchLabel_11')}`].from.message}</div>
                )}
              </div>
            </li></ul>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="left" >
              {[12, 14, 16, 18].map((e, i) => renderSelect(e, i))}
            </div>
            <div className="middle" >
              {[13, 15, 17, 19].map((e, i) => renderSelect(e, i))}
            </div>
          </div>
          <div className="submit-container">
            <SearchButton tabIndex={26} type="submit" data-testid="search-submit" {...errorFields.length > 0 && { disabled: true }} />
          </div>
        </div>
      </form>
    </FilterTabWrapper>
  )
}

DetailVehicleTab.propTypes = {
  onSearchSubmit: PropTypes.func
}
